import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Header';
import ServiceDetail from '../../components/ServiceDetail';

const ServiceQuestionsPage = () => {
    const { id } = useParams();
    const location = useLocation();
    const headerText = location.state?.headerText as string;
    const navigate = useNavigate();

    const isFirstPage = location.key === 'default';
    const handleBack = isFirstPage ? () => navigate('/', { replace: true }) : undefined;

    if (!id) return navigate(-1);

    return (
        <div className='flex flex-col min-h-full'>
            <Header navTitle={headerText} onBack={handleBack} />
            <div className='grow flex flex-col px-20 py-10 gap-15 h-full'>
                <ServiceDetail id={id} />
            </div>
        </div>
    );
};

export default ServiceQuestionsPage;
